export default __webpack_public_path__ + "static/media/bg-banner-mobile.d537ef72.jpg";